import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseUrl, apiUrl } from "../../../utils/apis";
import type {
  Case,
  CasePayload,
  UpdateCasePayload,
  CasesApiResponse,
} from "./types";

export const casesApi = createApi({
  reducerPath: "casesApi",

  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers) => {
      const token = sessionStorage.getItem("token");
      headers.set("Content-Type", "application/json");
      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),

  tagTypes: ["Cases"],

  endpoints: (builder) => ({

   
    getCasesList: builder.query<
  CasesApiResponse,
  {
    search?: string;
    specialization_id?: number | string;
    status?: string;
    case_type?: string;
    page: number;
    limit: number;
  }
>({
  query: (params) => ({
    url: apiUrl.casesUrl,
    method: "GET",
    params,
  }),
  providesTags: ["Cases"],
}),


    
    createCase: builder.mutation<Case, CasePayload>({
      query: (body) => ({
        url: apiUrl.casesUrl,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Cases"],
    }),

 
updateCase: builder.mutation<
  Case,
  { id: number | string; data: Partial<UpdateCasePayload> }
>({
  query: ({ id, data }) => ({
    url: `/workflow/cases/${id}/`,
    method: "PUT",
    body: data,
  }),
  invalidatesTags: (result, error, { id }) => [
    { type: "Cases", id },
  ],
}),


    
    deleteCase: builder.mutation<{ success: boolean }, number>({
      query: (id) => ({
        url: `${apiUrl.casesUrl}${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["Cases"],
    }),

  
    searchCases: builder.query<
      CasesApiResponse,
      { search?: string; search_by?: string }
    >({
      query: ({ search = "", search_by = "" }) => ({
        url: apiUrl.casesUrl,
        params: {
          search,
          search_by,
        },
      }),
      providesTags: ["Cases"],
    }),
    
    
getCaseDetails: builder.mutation<any, string | number>({
  query: (id) => ({
    url: `${apiUrl.casesUrl}${id}/`,
    method: "GET",
  }),
}),

  }),
});

export const {
  useGetCasesListQuery,        
  useCreateCaseMutation,
  useUpdateCaseMutation,
  useDeleteCaseMutation,
  useLazySearchCasesQuery,
 useGetCaseDetailsMutation
} = casesApi;
